<y42-logo-loader *ngIf="state.gridLoading" class="flex justify-center items-center h-full"></y42-logo-loader>
<ag-grid-angular
  class="ag-theme-basic-bordered-table h-full w-full"
  [gridOptions]="gridOptions"
  [components]="frameworkComponents"
  [columnDefs]="columnDefs"
  [rowData]="logs"
  (columnResized)="onColumnResized()"
  (gridReady)="onGridReady($event)"
>
</ag-grid-angular>
